import React from 'react';
import Box from '@rsos/components/capstone/base/Box';
import Select from '@rsos/components/capstone/base/Select';
import { ErrorWrapper } from '@rsos/components/capstone/base/form/ErrorsWrapper';
import { InputTextLabel } from '@rsos/components/capstone/base/form/inputs/InputText/InputText.styles.js';

const AuthorityNameSelect = ({ value, onChange, label, error, data }) => {
  const buildOption = agency => ({
    id: agency.id,
    label: agency.display_name,
    value: agency.display_name,
  });

  const customAuthorityNameSelectStyles = {
    menuList: styles => ({
      ...styles,
      height: 150,
    }),
  };

  return (
    <Box>
      {label && (
        <InputTextLabel size="small" mb="3px">
          {label}
        </InputTextLabel>
      )}
      <Select
        options={data && data.map(buildOption)}
        placeholder="Select Agency"
        value={value}
        onChange={onChange}
        noGap
        styles={customAuthorityNameSelectStyles}
      />
      {error ? <ErrorWrapper error={error} /> : null}
    </Box>
  );
};

export default AuthorityNameSelect;
